import { Button, type ButtonProps } from "@base-ui/react";
import type { IconProps } from "@obs/icons";
import { colors, measure } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";
import type { ReactElement } from "react";

const styles = stylex.create({
	base: {
		alignItems: "center",
		backgroundColor: "transparent",
		blockSize: measure.sizeXl,
		borderWidth: 0,
		WebkitTapHighlightColor: "transparent",
		color: {
			":hover": colors.accentTxtDefaultActive,
			default: colors.accentTxtDefault,
		},
		cursor: "pointer",
		display: "flex",
		inlineSize: measure.sizeXl,
		justifyContent: "center",
		padding: 0,
	},
});

type TopBarActionIconProps = Omit<ButtonProps, "children"> & {
	icon: {
		Component: (props: IconProps) => ReactElement;
	} & Omit<IconProps, "size" | "iconColor">;
};

export const ActionIcon = ({ icon, ...buttonProps }: TopBarActionIconProps) => {
	const { Component, ...iconProps } = icon;
	return (
		<Button {...stylex.props(styles.base)} {...buttonProps}>
			<Component {...iconProps} iconColor="currentColor" />
		</Button>
	);
};
